import { Button } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import * as XLSX from 'xlsx';
import Iconify from '../iconify/Iconify';

const ExportExcelTabele = ({
    tableRef,
    nameBook = 'Sheet 1',
    titleButton = t('export_excel'),
    icon = 'material-symbols:cloud-download-outline',
}) => {
    const handleExport = () => {
        const table = tableRef.current;

        if (!table || table.tagName !== 'TABLE') {
            console.error('Invalid table ref');
            return;
        }

        const headers = Array.from(table.querySelectorAll('thead th')).map((th) => {
            const colSpan = th.getAttribute('colSpan');
            return { text: th.textContent.trim(), colSpan: colSpan ? parseInt(colSpan) : 1 };
        });

        const rows = Array.from(table.querySelectorAll('tbody tr')).map((row) =>
            Array.from(row.querySelectorAll('td, th')).map((cell) => {
                const rowSpan = cell.getAttribute('rowSpan');
                const colSpan = cell.getAttribute('colSpan');
                return {
                    text: cell.textContent.trim(),
                    rowSpan: rowSpan ? parseInt(rowSpan) : 1,
                    colSpan: colSpan ? parseInt(colSpan) : 1,
                };
            })
        );

        const data = formatData(headers, rows);

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(data);

        const mergeCells = getMergeCells(headers, rows);
        mergeCells.forEach((mergeCell) => {
            XLSX.utils.sheet_set_merge(worksheet, mergeCell.s.r, mergeCell.s.c, mergeCell.e.r, mergeCell.e.c);
        });

        XLSX.utils.book_append_sheet(workbook, worksheet, nameBook);

        XLSX.writeFile(workbook, `${nameBook}.xlsx`);
    };

    const formatData = (headers, rows) => {
        const headerRow = headers.map((header) => header.text);

        const dataRows = rows.map((row) => {
            const dataRow = [];
            let colIndex = 0;

            row.forEach((cell) => {
                const { text, rowSpan, colSpan } = cell;

                if (rowSpan > 1 || colSpan > 1) {
                    dataRow.push({ text, rowSpan, colSpan });
                } else {
                    dataRow.push(text);
                }

                colIndex += colSpan;
            });

            return dataRow;
        });

        return [headerRow, ...dataRows];
    };

    const getMergeCells = (headers, rows) => {
        const mergeCells = [];

        let rowIndex = 0;
        let colIndex = 0;

        rows.forEach((row) => {
            row.forEach((cell) => {
                const { rowSpan, colSpan } = cell;

                if (rowSpan > 1 || colSpan > 1) {
                    const mergeCell = {
                        s: { r: rowIndex, c: colIndex },
                        e: { r: rowIndex + rowSpan - 1, c: colIndex + colSpan - 1 },
                    };

                    mergeCells.push(mergeCell);
                }

                colIndex += colSpan;
            });

            rowIndex++;
            colIndex = 0;
        });

        return mergeCells;
    };
    return (
        <Button onClick={handleExport} variant="contained" startIcon={<Iconify icon={icon} />}>
            {titleButton}
        </Button>
    );
};

export default ExportExcelTabele;
